import axios from 'axios';

import { LeadAppointment } from './lead.types';

const leadRequest = axios.create({
  validateStatus: (status) => status >= 200 && status < 500,
});

type LeadRequestData = {
  leadId: number;
  franchiseeId?: number;
  cleaningDate?: string;
  appointment?: LeadAppointment
}

const leadSession = ({
  get: async () => {
    const response = await leadRequest.get('/api/lead-session/')
      .then(({ data }) => data)
      .catch((error) => error);
    return response;
  },
  set: async (
    leadId : number,
    franchiseeId?: number,
    cleaningDate?: string,
    appointment?: LeadAppointment,
  ) => {
    let requestData : LeadRequestData = { leadId };
    if (franchiseeId) {
      requestData.franchiseeId = franchiseeId;
    }
    if (cleaningDate) {
      requestData.cleaningDate = cleaningDate;
    }
    if (appointment) {
      requestData.appointment = appointment;
    }
    // console.log("Setting lead with data: ", requestData)
    const response = await leadRequest.post('/api/lead-session/', requestData)
      .then(({ data }) => data)
      .catch((error) => error);
    return response;
  },
  clear: async () => {
    const response = await leadRequest.delete('/api/lead-session/', {})
      .then(({ data }) => data)
      .catch((error) => error);
    return response;
  },

});

export default leadSession;
